/**
 * Selector to get whether the job end at dialog is open
 * @param {Object} state - Redux state object
 * @returns {boolean} True if the dialog is open, false otherwise
 */
export const getJobCloseAtDialogOpen = (state) => {
  return state?.jobCloseAtDialog?.open || false;
};
